<template>
  <ul class="tablist flex-wrap">
    <li
      v-for="item in list"
      :key="item.id"
      class="tabitem"
      :class="{ active: item.id == activeId }"
      @click="updateTab(item)"
    >
      {{ item.directory_name }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Tablist',
  props: {
    list: Array,
    activeId: String
  },
  methods: {
    updateTab(item) {
      this.$emit('updateCurrentPage', item.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.tablist {
  .tabitem {
    width: 180px;
    height: 60px;
    background-color: #f0f3fa;
    color: #adc6ff;
    font-size: 18px;
    text-align: center;
    line-height: 60px;
    cursor: pointer;
    &.active {
      background-color: $color_blue;
      color: #fff;
    }
    &:first-child {
      border-radius: 15px 0 0 0;
    }
    &:last-child {
      border-radius: 0 15px 0 0;
    }
  }
}
</style>
